
import Employees from './Employees.vue'

export default {
    name: 'EmployeesPerformingTreatment',
    components: { Employees },
    props: {
        treatmentItem: {
            required: true,
        },
        selectedSalon: {
            required: false,
            default: null
        },
    },

    computed: {
        sites() {
            return this.$store.getters['salon/getSalons']
        },
        employees() {
            //Filters out only the employees who perform this treatment.
            let employees = this.$store.getters["employees/getEmployeesBySiteId"](this.selectedSalon.siteId)
            return employees ? employees.filter(employee => employee.treatments.includes(this.treatmentItem.treatmentId) && employee.availableForOnlineBooking) : []
        },
    },

    async mounted() {
        await this.$store.dispatch("employees/getSiteEmployees", this.selectedSalon.siteId);
    }
}
